export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_ERROR = "CREATE_USER_ERROR";
export const CREATE_USER_PENDING = "CREATE_USER_PENDING";
export const CLEAR_USER_ERROR = "CLEAR_USER_ERROR";
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const OPEN_CREATE_USER_MODAL = "OPEN_CREATE_USER_MODAL";
export const CLOSE_CREATE_USER_MODAL = "CLOSE_CREATE_USER_MODAL";
export const SET_USERS_PENDING = "SET_USERS_PENDING";
export const SET_USERS_LIST = "SET_USERS_LIST";
export const SET_USERS_LIST_ASYNC = "SET_USERS_LIST_ASYNC";
export const SET_USER_DETAILS_INITIAL_STATE = "SET_USER_DETAILS_INITIAL_STATE";
export const SET_RETAILERS_LIST_ASYNC = "SET_RETAILERS_LIST_ASYNC";
export const SET_FILTERED_STATES_LIST_ASYNC = "SET_FILTERED_STATES_LIST_ASYNC";
export const ADD_USER_FORM = "ADD_USER_FORM ";
export const SET_LOADING = "SET_LOADING";
export const ENABLE_USER_ACCOUNT_FORM = "ENABLE_USER_ACCOUNT_FORM"
export const SET_TEST_VALUE = "SET_TEST_VALUE"
export const SUBMIT_PENDING = "SUBMIT_PENDING"
export const SUBMIT_SUCCESS = "SUBMIT_SUCCESS"
export const SUBMIT_ERROR = "SUBMIT_ERROR"
export const CREATE_USERS_PENDING = "CREATE_USERS_PENDING";
export const CREATE_USERS_SUCCESS = "CREATE_USERS_SUCCESS";
export const CREATE_USERS_ERROR = "CREATE_USERS_ERROR";
export const USER_LIST_ERROR = "USER_LIST_ERROR";
export const CLEAR_USER_LIST_ERROR = "CLEAR_USER_LIST_ERROR";
export const CLEAR_CREATE_USERS_ERROR = "CLEAR_CREATE_USERS_ERROR";

export const USER_EXPORT_HEADERS = [
  "NAME",
  "EMAIL",
  "ROLE",
  "ORGANIZATION NAME",
  "MOBILE NUMBER",
  "MANAGED BY",
  "MANAGED BY EMAIL",
  "ASSIGNED DEVICES",
  "AVAILABLE DEVICES",
  "ACCOUNT  STATUS",
  "ACTIVATION STATUS",
  "CREATED DATE",
];
